var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolunteers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 286.9,
    height: 266.46,
    viewBox: "0 0 286.9 266.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-6.77 0.03)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 292,
    height: 266,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.1,264.6H92.7a16.9,16.9,0,0,1-16.9-17V18.8a16.9,16.9,0,0,1,16.9-17H207.3a16.9,16.9,0,0,1,16.9,17V247.6A17.2,17.2,0,0,1,207.1,264.6Z",
    transform: "translate(-6.77 0.03)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7,254.1a6.47,6.47,0,0,1-6.4-6.5V18.8a6.53,6.53,0,0,1,6.4-6.5H207.3a6.47,6.47,0,0,1,6.4,6.5V247.6a6.53,6.53,0,0,1-6.4,6.5Z",
    transform: "translate(-6.77 0.03)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7,248.9a1.32,1.32,0,0,1-1.3-1.3V18.8a1.32,1.32,0,0,1,1.3-1.3H207.3a1.32,1.32,0,0,1,1.3,1.3V247.6a1.32,1.32,0,0,1-1.3,1.3Z",
    transform: "translate(-6.77 0.03)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8,36.9H224",
    transform: "translate(-6.77 0.03)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8,228.1H224",
    transform: "translate(-6.77 0.03)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.5,241.7h28.8",
    transform: "translate(-6.77 0.03)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,116a1.7,1.7,0,1,0,0,3.4h21.8a2.86,2.86,0,0,0,2.9-3v-8.5a11.09,11.09,0,0,0-6.1-10,7.26,7.26,0,1,0-12.4-5.2,7.33,7.33,0,0,0,2,5.2c-.2,0-.4.2-.6.2a15.23,15.23,0,0,0-6.1-5.7,8.78,8.78,0,0,0,2.9-6.5,8.6,8.6,0,1,0-17.2,0,8.78,8.78,0,0,0,2.9,6.5,12.08,12.08,0,0,0-6.1,5.7.73.73,0,0,0-.6-.2A7.26,7.26,0,1,0,125,92.7a7.33,7.33,0,0,0,2,5.2,11.09,11.09,0,0,0-6.1,10v8.5a2.93,2.93,0,0,0,2.9,3h21.7a1.7,1.7,0,0,0,0-3.4h-5.9V104.9a10.1,10.1,0,0,1,20.2,0V116Zm13.6-27.1a3.9,3.9,0,1,1-3.9,3.9A4,4,0,0,1,167.6,88.9Zm7.7,19V116H163.6V104.9a18.7,18.7,0,0,0-.4-3.5A7.75,7.75,0,0,1,175.3,107.9Zm-42.4-19a3.9,3.9,0,1,1-3.9,3.9A4,4,0,0,1,132.9,88.9Zm3.9,16V116H125v-8.1a7.76,7.76,0,0,1,12.1-6.5A30.56,30.56,0,0,0,136.8,104.9Zm13.4-13.6a5.14,5.14,0,0,1-5.1-5.2,5.21,5.21,0,0,1,5.1-5.2,5.2,5.2,0,0,1,0,10.4Z",
    transform: "translate(-6.77 0.03)",
    fill: "#71c4ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.5,141a5,5,0,0,0-6.8,0l-41.1,41.3L218.3,158a4.81,4.81,0,0,0-6.8,6.8l24.2,24.3,6.8,6.8,6.8-6.8,41.1-41.3A4.86,4.86,0,0,0,290.5,141Z",
    transform: "translate(-6.77 0.03)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9,58.8a25,25,0,0,0-22,12.9A25.27,25.27,0,0,0,8.6,84.2a22.88,22.88,0,0,0,1.8,9.2c2.4,8.1,9.2,20.8,27,36l18.5,16.8,18.5-16.8c17.8-14.9,24.6-27.7,27.2-35.8a26,26,0,0,0,1.8-9.2A25.37,25.37,0,0,0,77.9,58.8Z",
    transform: "translate(-6.77 0.03)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7,125.4C23.8,111.2,17.4,99.4,15,92l-.2-.4a20.79,20.79,0,0,1-1.5-7.4,20.2,20.2,0,0,1,37.8-9.9l4.6,7.9,4.6-7.9A20.46,20.46,0,0,1,77.9,64,20.17,20.17,0,0,1,98.1,84.3a20.79,20.79,0,0,1-1.5,7.4v.2c-2.4,7.4-8.8,19.2-25.7,33.4L55.7,139Z",
    transform: "translate(-6.77 0.03)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.3,160.8l-11.6-11.6a6.65,6.65,0,0,1,9.4-9.4l20.7,20.5",
    transform: "translate(-6.77 0.03)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.5,160.8l11.6-11.6a6.65,6.65,0,0,0-9.4-9.4l-20.9,20.5",
    transform: "translate(-6.77 0.03)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.1,139.6a6.43,6.43,0,0,0-9.5.4,6.85,6.85,0,0,0,.6,9.4l1.3,1.3a13.83,13.83,0,0,1-7.9-12.5V117.5c0-3.1-2.2-6.1-5.1-6.6a6.57,6.57,0,0,0-7.9,6.5v33.9a4.45,4.45,0,0,0,1.3,3.3l25,29.3a5.92,5.92,0,0,1,1.3,3.3V197H150V160Z",
    transform: "translate(-6.77 0.03)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7,139.6a6.43,6.43,0,0,1,9.5.4,6.85,6.85,0,0,1-.6,9.4l-1.3,1.3a13.83,13.83,0,0,0,7.9-12.5V117.5c0-3.1,2.2-6.1,5.1-6.6a6.57,6.57,0,0,1,7.9,6.5v33.9a4.45,4.45,0,0,1-1.3,3.3l-24.6,29.3a5.92,5.92,0,0,0-1.3,3.3V197H149.6V160Z",
    transform: "translate(-6.77 0.03)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.3,202.3V187.4L97.5,158a9.78,9.78,0,0,1-2.6-6.8V117.3a11.8,11.8,0,0,1,11.7-11.8,9.74,9.74,0,0,1,2.4.2,11.93,11.93,0,0,1,9.4,11.8V134a13.58,13.58,0,0,1,5.9-1.5,12.55,12.55,0,0,1,8.3,3.3l17.3,17,17.3-17a11.47,11.47,0,0,1,8.3-3.3,13.94,13.94,0,0,1,5.9,1.5V117.4a11.93,11.93,0,0,1,9.4-11.8,9.74,9.74,0,0,1,2.4-.2,11.8,11.8,0,0,1,11.7,11.8v33.9a10.14,10.14,0,0,1-2.6,6.8l-25,29.3v14.9h-55v.2Z",
    transform: "translate(-6.77 0.03)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.37
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteers);
export default __webpack_public_path__ + "static/media/volunteers.379fb672.svg";
export { ForwardRef as ReactComponent };